import { render, staticRenderFns } from "./TicketInfoHeader.vue?vue&type=template&id=78a0768e&"
import script from "./TicketInfoHeader.vue?vue&type=script&lang=ts&"
export * from "./TicketInfoHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports